<div class="ap-margin-bottom-3">
    {{ 'financial-obligations.personal-loan.monthly-payment' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>
<ap-amount-input
    id="personalLoanMonthlyAmount"
    [helpText]="'financial-obligations.personal-loan.monthly-payment.help-text' | apContent"
    [label]="'global.monthly-input.label' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="financial-obligations.personal-loan.amount.additional-info.title"
    contentKey="financial-obligations.personal-loan.amount.additional-info.content"
    modalUrlKey="financial-obligations.personal-loan.amount.additional-info.title"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
